<template>
  <b-container id="my-services">
    <b-row class="justify-content-md-center">
      <b-col md="9" lg="8">
        <b-card title="Was bieten Sie an?">
          <b-spinner v-if="isLoading" />
          <service-picker
            align="left"
            class="mb-3 mt-3"
            :all-services="servicesOptions"
            v-model="pickedServices"
          />
          <p align="left">
            <b>Annahmetext:</b>
          </p>
          <b-form-textarea style="resize: none" v-model="acceptText" rows="8">
          </b-form-textarea>
          <br />
          <b-alert
            fade
            dismissible
            @dismissed="message = ''"
            :show="message.length > 0"
            :variant="success ? 'success' : 'danger'"
            >{{ message }}
          </b-alert>
          <br />

          <b-button
            :disabled="isSaving"
            @click="save"
            class="w-25"
            style="min-width: 100px"
          >
            Speichern

            <b-spinner small v-if="isSaving" />
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ServicePicker from "../components/ServicePicker";

export default {
  name: "MyServices",
  components: { ServicePicker },
  data() {
    return {
      servicesOptions: [],
      pickedServices: [],
      acceptText: "",
      isLoading: true,
      isSaving: false,
      message: "",
      success: true
    };
  },
  created() {
    this.$http
      .get("/user/my-services")
      .then(response => {
        let data = response.data.data;
        this.pickedServices = data.user.services.map(service => service.serId);
        this.servicesOptions = data.services;
        this.acceptText = data.acceptText;
      })
      .finally(() => (this.isLoading = false));
  },
  methods: {
    save() {
      let form = new FormData();
      for (let serviceId of this.pickedServices) {
        form.append("services[]", serviceId);
      }
      form.append("acceptText", this.acceptText);
      this.message = "";
      this.success = true;
      this.isSaving = true;
      this.$http
        .post("/user/assign-service", form)
        .then(response => {
          this.message = response.data.message;
        })
        .catch(() => {
          this.success = false;
          this.message = "Änderungen konnten nicht gespeichert werden";
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }
};
</script>

<style scoped></style>
